import { render, staticRenderFns } from "./PurchaseReturnsDetail.vue?vue&type=template&id=1c8e4678&scoped=true&"
import script from "./PurchaseReturnsDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e4678",
  null
  
)

export default component.exports